import dayjs from "dayjs";

export function checkIfDateADayBeforeNow(dateBefore) {
  const date1 = dayjs(dateBefore).format("MM-DD-YYYY");
  const dayDate1 = dayjs(date1);
  const now = dayjs().add(0, "day").format("MM-DD-YYYY"); //.add only for testing. Needs to be 0 when not testing
  const nowOnlyDay = dayjs(now);
  return dayDate1.diff(nowOnlyDay, "day") < 0;
}
